import { PromotionStatusEnum } from "./status-enum";

export const promotionStatusLabels = Object.freeze({
  [PromotionStatusEnum.DRAFT]: "Draft",
  [PromotionStatusEnum.ACTIVE]: "Aktif",
  [PromotionStatusEnum.PAUSED]: "Dijeda",
  [PromotionStatusEnum.DEPLETED]: "Habis",
  [PromotionStatusEnum.EXPIRED]: "Kedaluwarsa",
});
